import { Routes, RouterModule } from '@angular/router';

import { OfferListComponent } from './pages/offer-list/offer-list.component';
import { OfferComponent } from './pages/offer/offer.component';
import { OperationListComponent } from './pages/operation-list/operation-list.component';
import { AddOfferComponent } from './pages/add-offer/add-offer.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AuthGuard } from './services/auth/auth.guard';

import { OfferListResolve } from './pages/offer-list/offer-list.resolve';
import { OfferResolve } from './pages/offer/offer.resolve';
import { OperationListResolve } from './pages/operation-list/operation-list.resolve';
import { OffersCountResolve } from './pages/offer-list/offers-count.resolve';
import { OperationCountResolve } from './pages/operation-list/operation-count.resolve';
import { ChipsCountResolve } from './resolvers/chips-count.resolve';
import { ActivityCountResolve } from "./resolvers/activity-count.resolve";
import { AddOfferResolve } from './pages/add-offer/add-offer.resolve';

const appRoutes: Routes = [
  {
    path: '',
    component: OfferListComponent,
    resolve: {
      offers: OfferListResolve,
      activityCount: ActivityCountResolve,
      offersCount: OffersCountResolve
    },
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'offer/:offerId',
    component: OfferComponent,
    resolve: {
      offer: OfferResolve
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'operation-list',
    component: OperationListComponent,
    resolve: {
      operations: OperationListResolve,
      operationsCount: OperationCountResolve,
      activityCount: ActivityCountResolve,
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'add-offer/:offerId',
    component: AddOfferComponent,
    resolve: {
      offer: AddOfferResolve
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'add-offer',
    component: AddOfferComponent,
    canActivate: [AuthGuard]
  },

  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: '/not-found' }
];

export const routing = RouterModule.forRoot(appRoutes);
